"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Tagging_1 = require("./_Tagging");
exports.PutBucketTaggingInput = {
    type: "structure",
    required: ["Bucket", "Tagging"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        },
        ContentMD5: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "Content-MD5"
        },
        Tagging: {
            shape: _Tagging_1._Tagging,
            locationName: "Tagging",
            xmlNamespace: {
                uri: "http://s3.amazonaws.com/doc/2006-03-01/"
            }
        }
    },
    payload: "Tagging"
};
//# sourceMappingURL=PutBucketTaggingInput.js.map